import React from 'react'
import { connect } from 'react-redux'

import Users from './Users'

import { fetchLocationsList } from '../Locations/actions'
import { fetchUsersList } from './actions'



class UsersList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.dispatch(fetchLocationsList);
        this.props.dispatch(fetchUsersList)
    }

    render() {
        return (
            <Users usersList={this.props.users.users} locations={this.props.locations} />
        );
    }
}

const mapStateToProps = state => ({
    users: state.users,
    locations: state.locations.locationsList
});

export default connect(mapStateToProps)(UsersList)
